<hs-lazy-load-panel [content]="lazyLoadPanelContent" [panelKey]="panelKey">
</hs-lazy-load-panel>

<ng-template #lazyLoadPanelContent>
  <hs-no-loaded-account [content]="securitiesSelected"> </hs-no-loaded-account>
</ng-template>

<ng-template #securitiesSelected>
  <hs-securities-selected
    #securitiesSelectedComponent
    [content]="loadedAccountDependentContent"
    (securitySelectionChange)="onSecuritySelectionChanged($event)"
  >
  </hs-securities-selected>
</ng-template>

<ng-template #loadedAccountDependentContent>
  <div class="d-flex flex-column w-100 h-100">
    <div class="distributions-grid-container" #distributionsGridContainer>
      <hs-distributions-grid
        #distributionsGrid
        [savedViews]="savedViewsState$ | async"
        [data]="distributions$ | async"
        [dateRange]="distributionsDateRange$ | async"
        [windowDate]="windowDate$ | async"
        (enterPredictionAction)="onEnterPrediction($event)"
        (quickEnterPredictionAction)="onQuickEnterPrediction($event)"
        (editTransactionAction)="onEditTransaction($event)"
        (dateRangeChange)="onDistributionsDateRangeChanged($event)"
      >
        <hs-distributions-properties
          #distributionsProperties
          [securityData]="securityData$ | async"
          [hasLlaRates]="hasLlaRates"
          (securityDataForMMF)="setSecurityDataForMMF($event)"
        ></hs-distributions-properties>
      </hs-distributions-grid>
    </div>
    <hs-resize-handle
      [elem1]="distributionsGridContainer"
      [elem2]="subPanels"
      [initialResizeHandleState]="state?.resizeHandleState"
      (resizeFinished)="onResizeFinished($event)"
    ></hs-resize-handle>
    <div id="distributions-sub-panels" #subPanels>
      <ul
        ngbNav
        #nav="ngbNav"
        #subPanelsNav="ngbNav"
        class="nav-tabs"
        [(activeId)]="activeTab"
      >
        <li [ngbNavItem]="1">
          <a class="distributions-nav-item" ngbNavLink>Accrued Interest</a>
          <ng-template ngbNavContent>
            <hs-accrued-interest-grid
              #accruedInterestGrid
              [savedViews]="savedViewsState$ | async"
              [data]="accruedInterest$ | async"
              [interestFormat]="interestFormat$ | async"
            >
              <hs-accrued-interest-properties
                #accruedInterestProperties
                [interestFormat]="interestFormat$ | async"
                [dateRange]="accruedInterestDateRange$ | async"
                (dateRangeChange)="onAccruedInterestDateRangeChanged($event)"
                (interestFormatChange)="onAccruedInterestFormatChanged($event)"
              >
              </hs-accrued-interest-properties>
            </hs-accrued-interest-grid>
          </ng-template>
        </li>

        <li [ngbNavItem]="2">
          <a class="distributions-nav-item" ngbNavLink> Factor History </a>
          <ng-template ngbNavContent>
            <hs-factor-history-grid
              #factorHistoryGrid
              [savedViews]="savedViewsState$ | async"
              [data]="factorHistory$ | async"
            ></hs-factor-history-grid>
          </ng-template>
        </li>
        <li [ngbNavItem]="3">
          <a class="distributions-nav-item" ngbNavLink> Coupon Rate History </a>
          <ng-template ngbNavContent>
            <hs-coupon-rate-history-grid
              #factorHistoryGrid
              [data]="couponRateHistory$ | async"
            ></hs-coupon-rate-history-grid>
          </ng-template>
        </li>
        <li [ngbNavItem]="4">
          <a class="distributions-nav-item" ngbNavLink> Dividend History </a>
          <ng-template ngbNavContent>
            <hs-dividend-history-grid
              #dividendHistoryGrid
              [data]="dividendHistory$ | async"
            ></hs-dividend-history-grid>
          </ng-template>
        </li>
        <li [ngbNavItem]="5" *ngIf="showMMFTab">
          <a class="distributions-nav-item" ngbNavLink> MMF Settings </a>
          <ng-template ngbNavContent>
            <hs-mmf-settings-grid
              #mmfSettingsGrid
              [data]="mmfSettings$ | async"
              [securityId]="securityId$ | async"
              [accountId]="accountId$ | async"
              (refreshDistribution)="onRefreshDistribution($event)"
            ></hs-mmf-settings-grid>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </div>
</ng-template>
